import { MinusIcon, PlusIcon } from '@/app/[locale]/_assets/icon-components'
import { HStack, Button, IconButton } from '@chakra-ui/react'

interface ICounter {
  variable: number
  color?: string
  onIncrease: () => void
  onDecrease: () => void
  min?: number
  max?: number
  height?: any
  width?: number | { [key: string]: string | number }
  unstyled?: boolean
  className?: any
  isDisabled?: boolean
}

export default function Counter({
  min,
  max,
  width,
  height,
  color,
  variable,
  onIncrease,
  onDecrease,
  className,
  isDisabled,
}: ICounter) {
  return (
    <HStack
      gap={0}
      rounded={16}
      className={className}
      bg={'background'}
      color='text'
      h={height ? height : 'fit-content'}
      width={width}
      display={'flex'}
      justifyContent={'space-between'}
    >
      <IconButton
        _hover={{ bg: 'text.muted' }}
        aria-label='minus-product'
        onClick={onDecrease}
        disabled={min === variable || isDisabled}
        h={'full'}
        roundedLeft={12}
        color='text'
        variant={'ghost'}
      >
        <MinusIcon color='currentColor' />
      </IconButton>
      <Button color={color ? color : ''} variant={'plain'}>
        {variable}
      </Button>
      <IconButton
        _hover={{ bg: 'text.muted' }}
        aria-label='plus-product'
        onClick={onIncrease}
        disabled={max === variable || isDisabled}
        roundedRight={12}
        h={'full'}
        color='text'
        variant={'ghost'}
      >
        <PlusIcon color='currentColor' />
      </IconButton>
    </HStack>
  )
}
